import axios from 'axios'

import * as uiTypes from '../store/modules/ui/types'
import * as httpErrors from '../store/modules/httpRequests/types'
import * as authTypes from '../store/modules/auth/types'
import * as userTypes from '../store/modules/user/types'

import store from '@/store/'
import router from '@/router'

export default function(requestObject) {
  store.commit(uiTypes.IS_LOADING, true)

  const baseURL = process.env.API_URL
  const token = `Bearer: ${store.getters.getAuthToken ? store.getters.getAuthToken : store.getters.getPatientToken}`

  const filteredUrl = requestObject.url.replace('??', '?')
  const url = `${baseURL}${filteredUrl}${filteredUrl.includes('?') ? '&' : '?'}${getPaginationParams(requestObject['page'])}`
  const headers = {Authorization: token}

  return axios({
    method: requestObject.method,
    url: url,
    data: requestObject.data,
    headers: headers
  }).then(res => {
    store.commit(httpErrors.SERVER_SHOW_OVERLAY, false)

    if(res.headers['content-type'] && res.headers['content-type'].includes('text/csv')) {
      return {headers: res.headers, data: res.data}
    }

    return res.data
  }).catch(err => {
    if(err.response) {
      const status = err.response.status
      const data = err.response.data

      handleError(status, data)

      throw {response: data}
    }
  }).finally(() => {
    store.commit(uiTypes.IS_LOADING, false)
  })
}

function handleError(statusCode, data) {
  switch(statusCode) {
    case 401:
      store.commit(authTypes.TOKEN, null)
      store.commit(userTypes.SET_USER, null)
      if (router.currentRoute && router.currentRoute.name !== 'Login') {
        router.replace({name: 'Login'})
      } else {
        populateOverlay(data)
      }
      break
    default:
      populateOverlay(data)
  }
}

function populateOverlay(data) {
  let message = null
  for(const key in data.errors) {
    if(Array.isArray(data.errors[key])) {
      message = `${formatKey(key)}${data.errors[key][0]}`
      break
    }
  }
  store.commit(httpErrors.SERVER_OVERLAY_MESSAGE, message)
  store.commit(httpErrors.SERVER_SHOW_OVERLAY, 'error')
}

function getPaginationParams(page) {
  if(!page || page == {}) {
    return ''
  }

  let result = ''

  for(const key in page) {
    result += `${key}=${page[key]}&`
  }

  return result
}

function formatKey(key) {
  if(key === 'messages') return ''
  let result = key.replace('_', ' ')
  result = result.charAt(0).toUpperCase() + result.slice(1) + ' '

  return result
}


//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/api/axios_wrapper.js
// module id = null
// module chunks = 